// utils/socket.js
import io from "socket.io-client";

let socket = null;

const initializeSocket = (token) => {
  if (!token) {
    console.warn("Thiếu token khi khởi tạo socket, kết nối có thể thất bại");
  }
  if (socket) {
    // Cập nhật token nếu đã tồn tại
    if (token) {
      socket.auth.token = `Bearer ${token}`;
    }
    if (!socket.connected) {
      socket.connect();
    }
    return socket;
  }

  socket = io(process.env.REACT_APP_API_URL || "https://tinhocquocte.com", {
    auth: {
      token: token ? `Bearer ${token}` : "",
    },
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
  });

  socket.on("connect", () => {
    console.log("Đã kết nối tới server WebSocket:", socket.id);
  });

  socket.on("disconnect", (reason) => {
    console.log("Ngắt kết nối WebSocket:", reason);
  });

  socket.on("connect_error", (err) => {
    console.error("Lỗi kết nối WebSocket:", err.message);
    if (err.message.includes("Token")) {
      socket.emit("auth_error", { message: "Token không hợp lệ hoặc hết hạn" });
    }
  });

  socket.on("reconnect", (attemptNumber) => {
    console.log("Kết nối lại thành công, lần thử thứ:", attemptNumber);
  });

  return socket;
};

const getSocket = () => {
  if (!socket) {
    console.warn("Socket chưa được khởi tạo, trả về null...");
    return null; // Trả về null thay vì ném lỗi
  }
  return socket;
};

const disconnectSocket = () => {
  if (socket && socket.connected) {
    socket.disconnect();
    console.log("Đã ngắt kết nối WebSocket");
    socket = null;
  }
};

export { initializeSocket, getSocket, disconnectSocket };